var nb = require('../../nb');
var ShopCartItem = nb.define({
    view: {
        'class': 'shop-cart-item',
        tag: 'li',
        'data-id': nb.bind('proId'),
        $html: {
            tag: "a",
            href: nb.bind('detailHref'),
            'class': 'clearfix',
            target: '_blank',
            $html: [{
                'class': 'item-left',
                $html: {
                    tag: 'img',
                    src: nb.bind('imgUrl')
                }
            }, {
                'class': 'item-right',
                $html: [{
                    'class': 'name',
                    $text: nb.bind('name')
                }, {
                    'class': 'sku ellipsis',
                    $html: [{
                        tag: 'span',
                        $text: '规格: '
                    }, {
                        tag: 'span',
                        $text: nb.bind('size')
                    }]
                }, {
                    'class': 'count',
                    $html: [{
                        tag: 'span',
                        $text: '数量: '
                    }, {
                        tag: 'span',
                        $text: nb.bind('num')
                    }]
                }, {
                    'class': 'price',
                    $html: [{
                        tag: 'span',
                        $text: '单价: '
                    }, {
                        tag: 'span',
                        $text: nb.bind('price')//price
                    }]

                }]
            }]
        }
    }
});
var ShopCartList = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'shop-cart-list',
        tag: 'ul'
    }
});
var ShopCartMenu = nb.define({
    view: {
        'class': ['shop-cart-menu', nb.bind('status')],
        $html: [{
            'class': "title",
            $text: "购物车"
        }, {
            'class': 'shop-cart-empty',
            $text: "购物车为空"
        }, {
            'class': ['shop-cart-have', nb.bind('shopCartStates')],
            $html: [{
                'class': 'scroll',
                $html: {
                    $type: ShopCartList,
                    $model: 'shopCartList'
                }
            }, {
                'class': 'total-count-wrapper',
                $html: [{
                    'class': 'total-text',
                    $text: "已选中商品总计"
                }, {
                    'class': 'total-count',
                    $text: nb.bind('totalPrice')
                }]
            }, {
                'class': 'go-settlement',
                $html: {
                    tag: 'a',
                    href: 'payOne.html',
                    $text: '前往结算'
                }
            }, {
                'class': 'show-shop-cart',
                $html: {
                    tag: 'a',
                    href: 'shopCart.html',
                    $text: '查看购物车'
                }
            }]
        }]
    },
    method: {
        init: function () {
            var $el = this.$();
            nb.model.onChange('showShopCart', function () {
                $el.addClass('showShopCart');
                setTimeout(function () {
                    $el.removeClass('showShopCart')
                },2000);
            }, this);
        }

    }
});
module.exports = {
    ShopCartMenu: ShopCartMenu,
    ShopCartItem: ShopCartItem
};


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/ShopCartMenu.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32